/*eslint-disable*/
export default waitlistOverlay => {
  $(window).load(() => {
    $(waitlistOverlay).find('div.waitlist-tab-modal-close').on('click touchstart', function () {
      $(waitlistOverlay).removeClass('is-active')
      $('body').css('overflow', 'auto')
      $('#wrapper').css('overflow', 'auto')
      $('#wrapper .content.container').css('overflow', 'auto')
      $('body').off('click.waitlistEvent touchstart.waitlistEvent')
    })
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/waitlist.js